import React from 'react'
import useCartContent from 'services/cart/hooks/use-cart-content'

export default function WhenEmptyCartContent (props) {
  const cartContent = useCartContent()

  if (cartContent.length > 0) return null

  return <>{props.children}</>
}
